import { useQuery } from "@tanstack/react-query";
import { axios } from "../../../shared/lib/axios";

export const getZoomContent = async ({ studentId, eventId }) => {
  const res = await axios.middleware.get(
    "https://template.cadernovirtual.com.br/ZoomSala.ashx",
    {
      params: {
        action: "token",
        alunoId: studentId,
        aulaId: eventId,
      },
    }
  );
  return res.url;
};

export const useZoomContent = ({ config, studentId, eventId } = {}) => {
  return useQuery({
    ...config,
    queryFn: () => getZoomContent({ studentId, eventId }),
    queryKey: ["zoomContent", { studentId, eventId }],
  });
};
